import type {InferenceApiResponse} from '@/types/inference';

import {getInferenceMockResponse} from './inferenceMock';

/** The host's live tour mock; `liveTourTile` is the insight code its tour highlights. */
export type LiveTourMock = InferenceApiResponse & {liveTourTile?: string};

let isInferenceMockEnabled = false;
let mockInference: LiveTourMock | undefined;

/** Re-applied on every init, so a re-init without the flags turns the mocks back off. */
const apply = ({useMockData, mockInference: inference}: {useMockData?: boolean; mockInference?: LiveTourMock}) => {
    isInferenceMockEnabled = useMockData === true;
    mockInference = inference;
};

const isInferenceEnabled = () => isInferenceMockEnabled;

// The host's own mock (a live tour) wins over the built-in one.
const getInferenceResponse = () => mockInference ?? getInferenceMockResponse();

const getLiveTourTile = () => mockInference?.liveTourTile;

export default {apply, isInferenceEnabled, getInferenceResponse, getLiveTourTile};
